import "./TwoColorAcrylicEngravingStock.module.css";
import Header from "@/reusable_sections/Header";
import PageHeader from "./sections/PageHeader";
import DirectAnswerBlock from "./sections/DirectAnswerBlock";
import WhatIsTwoColorAcrylic from "./sections/WhatIsTwoColorAcrylic";
import AcrylicProperties from "./sections/AcrylicProperties";
import StockColors from "./sections/StockColors";
import WhenToChooseAcrylic from "./sections/WhenToChooseAcrylic";
import WhereAcrylicIsUsed from "./sections/WhereAcrylicIsUsed";
import FaqAccordion from "./sections/FaqAccordion";
import ClosingCta from "./sections/ClosingCta";
import Footer from "@/reusable_sections/Footer";
export default function TwoColorAcrylicEngravingStockPage() {
  return <div>
      <Header />
      <PageHeader />
      <DirectAnswerBlock />
      <WhatIsTwoColorAcrylic />
      <AcrylicProperties />
      <StockColors />
      <WhenToChooseAcrylic />
      <WhereAcrylicIsUsed />
      <FaqAccordion />
      <ClosingCta />
      <Footer />
    </div>;
}